module.exports = __webpack_public_path__ + "img/pregnant_middle_pic.992f3321.png";